define('v3/Pages/AbilityGraph/ViewModels/Report.ViewModel',[
	'jquery',
	'knockout',
	'v3/Common/Models/enums',
	'lodash',
	'v3/Common/Services/urlService',
	'v3/Common/Services/pageStateService'
], function ($, ko, enums, _, urlService, pageStateService) {
	function ReportViewModel (options) {
		var self = this;
		var rainbowChartComponent = null;
		self.selectedSubjectGroupId = ko.observable();

		options.navBackButtonParams = {
			name: pageStateService.getStringObservable('pupilName'),
			linkFunction: function () {
				urlService.pupilReviewPageUrl(
					self.selectedSubjectGroupId(),
					self.pupilId()
				).then(function (url) {
					window.location.assign(url);
				});
			}
		};

		self.navBackButtonParams = options.navBackButtonParams;

		self.enums = enums;
		self.pupils = options.pupils;
		self.pupilId = pageStateService.getNumberObservable('pupilId');
		self.pupilName = pageStateService.getStringObservable('pupilName');
		self.isRainbowChartLoaded = ko.observable(false);

		var pageStateSubjectGroupId = pageStateService.getNumberObservable('subjectGroupId');
		self.selectedSubjectGroupId(pageStateSubjectGroupId());

		self.activePupil = ko.computed(function () {
			var pupilId = self.pupilId();
			return ko.utils.arrayFirst(self.pupils, function (item) {
				return item.userId === pupilId;
			});
		});

		self.chartLevel = ko.observable(enums.chartLevel.subject);
		self.targetAbility = ko.observable(null);
		self.openEditTargetAbilityDialog = ko.observable(null);

		self.targetAbilityCalculationChanged = function (value) {
			if (rainbowChartComponent) {
				rainbowChartComponent.updateTargetAbility(value.percentile, value.ability, value.isSetAutomatically, value.lastAutomaticUpdate);
			}
		};

		self.initChartCallback = function (chartComponentModel) {
			rainbowChartComponent = chartComponentModel;
			self.openEditTargetAbilityDialog(chartComponentModel.openEditTargetAbilityDialog);
			chartComponentModel.targetAbility.subscribe(function (newTargetAbility) {
				self.targetAbility(newTargetAbility);
			});
		};
	}

	return ReportViewModel;
});

